exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h1[data-v-9e18eed0]{font-size:2.25rem;line-height:2.25rem;color:#2f2f2f;font-weight:700}@media (max-width:575px){h1[data-v-9e18eed0]{font-size:2rem;line-height:2rem}}.card-form-wrapper h1[data-v-9e18eed0],.faq-section h1[data-v-9e18eed0],.privacy h1[data-v-9e18eed0],.terms h1[data-v-9e18eed0]{width:100%;margin:0 auto 1.25rem;text-align:center;color:#16244f;font-size:1.75rem;font-weight:600;text-align:left}", ""]);

// exports
